import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=13296445&scoped=true&"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js&"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13296445",
  null
  
)

export default component.exports